import { AfterViewInit, Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FilterInputDatepickerTypes, FilterInputTypes, IFormDataModel } from '@foxeet/domain';
import { UnsuscriptionHandler } from '@foxeet/utils/*';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'ui-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  styleUrls: ['./dynamic-form.component.scss'],
})
export class DynamicFormComponent extends UnsuscriptionHandler implements AfterViewInit {
  // Enums
  public FilterInputTypes = FilterInputTypes;
  public FilterInputDatepickerTypes = FilterInputDatepickerTypes;

  public viewInit$ = new BehaviorSubject<boolean>(false);

  public arrayElement: IFormDataModel | null = null;
  public arrayFieldName: string = '';
  public arrayModel: IFormDataModel[][] | null = null;
  public arrayAddElement: IFormDataModel | null = null;

  @Input() title = '';

  @Input() id = '';

  @Input() model: IFormDataModel[][] = [];

  @Input() modelFormGroup!: FormGroup;
  @Input() modelParentFormGroup!: FormGroup;

  @Input() disabled = false;

  @Input() index: number | null = null;
  @Input() indexParent: number | null = null;

  constructor() {
    super();
  }

  ngAfterViewInit(): void {
    this.viewInit$.next(true);
    this.setFormArray();
  }

  public setFormArray() {
    const element = this.model.find((ar) => ar.find((el) => el.type === FilterInputTypes.ARRAY));
    if (element && element[0]) {
      this.arrayElement = element[0];
      this.arrayFieldName = this.arrayElement.controlName || '';
      this.arrayModel = this.arrayElement.arrayModel as IFormDataModel[][];
      this.arrayAddElement = this.arrayElement.arrayAddElement || null;
    }
  }

  public removeItemFromArray(element: IFormDataModel, index: number) {
    if (element.arrayRemoveCallback) {
      element?.arrayRemoveCallback(this.modelParentFormGroup, index);
    }
  }

  public getCalculatedClasses(element: IFormDataModel) {
    if (element.size) {
      return (Object.keys(element.size) as (keyof IFormDataModel['size'])[])
        .map((key) => {
          key === 'xs' ? `col-${element.size[key]}` : `col-${key}-${element.size[key]}`;
          switch (key) {
            case 'xs':
              return `col-${element.size[key]}`;
            case 'auto':
              return `col`;
            default:
              return `col-${key}-${element.size[key]}`;
          }
        })
        .join(' ');
    } else {
      console.error(`This element don't have size prop:`, element);
      return 'col';
    }
  }
}
